// Local
import Animate from './partials/animate';
import UploadControl from "./partials/upload-control";
import ProductSlider from "./partials/product-slider";
import AnimalsSlider from "./partials/animals-slider";
import GallerySlider from "./partials/gallery-slider";
import PageHeader from "./partials/page-header";
import MobileMenu from "./partials/mobile-menu";
import HeaderState from "./partials/header-state";
import Collapsable from "./partials/collapsable";
import Scene from "./partials/scene";
import LanguagePicker from "./partials/language-picker";
import WebshopMenuDropdown from "./partials/webshop-menu-dropdown";
import WebsiteSwitcher from "./partials/website-switcher";
import PageHeaderTitle from "./partials/page-header-title";
import LogoSlider from "./partials/logo-slider";
import HistoryItem from "./partials/history-item";
import GLightbox from "../../../../vendor/glightbox/glightbox.min";
import MenuModal from "./partials/menu-modal";
import AnimalImageAnimation from "./partials/animal-image-animation";
import MenuItemActive from "./partials/menu-item-active";
import Collapsables from "./partials/collapsables";
import ProductList from "./products/product-list";


window.initDom = ($wrapper) => {
    $wrapper.querySelectorAll('[data-animate]').forEach($item => (new Animate($item)));
    $wrapper.querySelectorAll('[data-upload]').forEach($el => new UploadControl($el));
    $wrapper.querySelectorAll('[data-product-swiper]').forEach($el => new ProductSlider($el));
    $wrapper.querySelectorAll('[data-logo-list]').forEach($el => new LogoSlider($el));
    //$wrapper.querySelectorAll('[data-logo-slider]').forEach($el => new LogoSlider($el));
    $wrapper.querySelectorAll('[data-animals-slider]').forEach($el => new AnimalsSlider($el));
    $wrapper.querySelectorAll('[data-gallery]').forEach($el => new GallerySlider($el));
    $wrapper.querySelectorAll('[data-page-header-extra-btn]').forEach($item => (new PageHeader($item)));
    $wrapper.querySelectorAll('[data-header]').forEach($el => new MobileMenu($el));
    $wrapper.querySelectorAll('[data-header]').forEach($el => new HeaderState($el));
    //$wrapper.querySelectorAll('[data-collapsable]').forEach($el => new Collapsable($el));
    $wrapper.querySelectorAll('[data-collapsables]').forEach($el => new Collapsables($el));
    $wrapper.querySelectorAll('[data-scene-carousel]').forEach($el => new Scene($el));
    $wrapper.querySelectorAll('[data-language-picker]').forEach($el => new LanguagePicker($el));
    $wrapper.querySelectorAll('[data-webshop-menu-dropdown]').forEach($el => new WebshopMenuDropdown($el));
    //$wrapper.querySelectorAll('[data-website-switcher]').forEach($el => new WebsiteSwitcher($el));
    $wrapper.querySelectorAll('[data-page-header-title]').forEach($el => new PageHeaderTitle($el));
    $wrapper.querySelectorAll('[data-history-item]').forEach($el => (new HistoryItem($el)));
    $wrapper.querySelectorAll('[data-menu-modal]').forEach($el => (new MenuModal($el)));
    $wrapper.querySelectorAll('[data-animal-image]').forEach($el => (new AnimalImageAnimation($el)));
    $wrapper.querySelectorAll('[data-header]').forEach($el => (new MenuItemActive($el)));

    $wrapper.querySelectorAll('[data-block-type="block-catalog-product-list"]').forEach($el => (new ProductList($el)));

    const lightbox = GLightbox({})



    $wrapper.querySelectorAll('[data-form]').forEach(async ($el) => {
        const Form = await import('./partials/form');
        (new Form.default($el));
    });
}

(function() {
    window.initDom(document);
})();
